'use strict';
const options_collection = {
  collectionsLoadMore: '.collections-load-more',
  rangeSlider: '.price-range .range-slider',
  rangeSliderMin: '.range-slider-min',
  rangeSliderMax: '.range-slider-max',
  minPriceRange: '.min-price-range',
  maxPriceRange: '.max-price-range',
  collectionSidebar: '#CollectionSidebar',
  collectionFilterBlocks: '.filter-blocks',
  productgridcontainer: '#productgridcontainer',
  collectionFiltersForm: '#CollectionFiltersForm',
  section: '.sec__collection-main',
};

class BtnFilter extends HTMLElement {
  constructor() {
    super();
    this.collectionSidebar = document.getElementById('CollectionSidebar');
    this.addEventListener('click', this.onOpen.bind(this), false);
  }
  onOpen() {
    if (!this.classList.contains('open')) {
      this.collectionSidebar.classList.add('open');
      document.documentElement.classList.add('open-drawer', 'open-sidebar');
      root.style.setProperty('padding-right', getScrollBarWidth.init() + 'px');
      this.classList.add('open');
    } else {
      this.collectionSidebar.classList.remove('open');
      document.documentElement.classList.remove('open-drawer', 'open-sidebar');
      root.style.removeProperty('padding-right');
      this.classList.remove('open');
    }
  }
}
customElements.define('btn-filter', BtnFilter);
class CloseFilter extends HTMLElement {
  constructor() {
    super();
    this.collectionSidebar = document.getElementById('CollectionSidebar');
    this.addEventListener('click', this.onClose.bind(this), false);
  }
  onClose() {
    this.collectionSidebar.classList.remove('open');
    document.documentElement.classList.remove('open-drawer', 'open-sidebar');
    document.querySelector('.btn-filter').classList.remove('open');
    root.style.removeProperty('padding-right');
  }
}
customElements.define('close-filter', CloseFilter);

class FacetApplyCanvas extends CloseFilter {
  constructor() {
    super();
    this.addEventListener('click', this.onClose.bind(this), false);
  }
}
customElements.define('facet-apply-canvas', FacetApplyCanvas);

class GridMode extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.gridMode.bind(this), false);
  }
  async gridMode() {
    if (this.classList.contains('active')) return;
    const view_mode = this.getAttribute('data-grid-mode');
    if (view_mode == 1) return;
  await Motion.animate(
      document.querySelectorAll(
        'motion-element.product-item__wrapper.slide_in'
      ),
      {
        transform: ['translateY(0)', 'translateY(3.5rem)'],
        opacity: [1, 0.01],
        visibility: ['visible', 'hidden'],
      },
      {
        duration: 0.3,
        delay: Motion.stagger(0.05),
        easing: [0, 0, 0.3, 1],
      }
    );


    for (var item of document.querySelectorAll('grid-mode')) {
      item.classList.remove('active');
    }
    const container_switch = document.querySelector(
      '.container-products-switch'
    );
    this.classList.add('active');
    const data_view_mode = container_switch.getAttribute('data-view-mode');
    container_switch.classList.remove('grid-columns-' + data_view_mode);
    container_switch.setAttribute('data-view-mode', view_mode);
    container_switch.classList.add('grid-columns-' + view_mode);
    Motion.animate(
      document.querySelectorAll(
        'motion-element.product-item__wrapper.slide_in'
      ),
      {
        transform: ['translateY(3.5rem)', 'translateY(0)'],
        opacity: [0.01, 1],
        visibility: ['hidden', 'visible'],
      },
      {
        duration: 0.3,
        delay: Motion.stagger(0.1),
        easing: [0, 0, 0.3, 1],
      }
    );
  }
}
customElements.define('grid-mode', GridMode);

class ViewMode extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.viewMode.bind(this), false);
  }
  viewMode() {
    const view_mode = this.getAttribute('data-view');
    if (this.classList.contains('actived')) return;
    var queryString = window.location.search;
    queryString = eventCollectionShopify.removeParam('view', queryString);
    if (view_mode == 'list') {
      var searchParams = queryString.replace('?', '') + '&view=list';
    } else {
      var searchParams = queryString.replace('?', '') + '&view=grid';
    }
    const url = eventCollectionShopify.renderUrl(searchParams);
    eventCollectionShopify.renderSectionFilter(url, searchParams);
  }
}
customElements.define('view-mode', ViewMode);

class FilterItem extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.filterItem.bind(this), false);
  }
  filterItem() {
    if (this.querySelector('.tooltip')) {
      this.querySelector('.tooltip').classList.toggle('current-filter');
    } else {
      if (this.closest('li')) {
        this.closest('li').classList.toggle('current-filter');
      }
    }
    const url = this.getAttribute('data-href');
    eventCollectionShopify.renderSectionFilter(url);
  }
}
customElements.define('filter-item', FilterItem);

class FacetClearAll extends CloseFilter {
  constructor() {
    super();
    this.addEventListener('click', this.filterItem.bind(this), false);
  }
  filterItem() {
    const url = this.getAttribute('data-href');
    eventCollectionShopify.renderSectionFilter(url);
    this.onClose();
  }
}
customElements.define('facet-clear-all', FacetClearAll);

class FilterSort extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.filterSort.bind(this), false);
  }
  filterSort() {
    const value = this.getAttribute('value');
    let queryString = window.location.search;
    queryString = eventCollectionShopify.removeParam('sort_by', queryString);
    const searchParams = queryString.replace('?', '') + '&sort_by=' + value;
    const url = eventCollectionShopify.renderUrl(searchParams);
    eventCollectionShopify.renderSectionFilter(url, searchParams);
  }
}
customElements.define('filter-sort', FilterSort);

class SelectSorter extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.activeFilterSort.bind(this), false);
  }
  activeFilterSort() {
    if (this.closest('.select-custom').classList.contains('active')) {
      this.closest('.select-custom').classList.remove('active');
    } else {
      this.closest('.select-custom').classList.add('active');
    }
  }
}
customElements.define('select-sorter', SelectSorter);

var eventCollectionShopify = (function () {
  return {
    init: function () {
      this.ionRangeSlider();
      this.deduplicateFilters();
      this.initCustomFilters();
      let windowWidth = window.innerWidth;
      if (windowWidth <= 1024) {
        const horizontal = document.querySelector('.horizontal-filter');
        if (horizontal) {
          const collapsible = document.querySelectorAll('collapsible-block');
          collapsible.forEach((e) => {
            e.classList.add('active');
          });
        }
      }
    },

    deduplicateFilters: function () {
      document.querySelectorAll('.filter-blocks ul.items[data-filter-label]').forEach((ul) => {
        const filterType = (ul.dataset.filterLabel || '').toUpperCase();
        const seenMap = new Map();

        const lis = Array.from(ul.querySelectorAll(':scope > li.item'));
        lis.forEach((li) => {
          const filterItem = li.querySelector('filter-item');
          if (!filterItem) return;
          const labelEl = filterItem.querySelector('.filter-label-name');
          const countEl = filterItem.querySelector('.filter-label-count');
          if (!labelEl) return;

          const rawLabel = labelEl.textContent.trim();
          let canonicalLabel = rawLabel;

          if (filterType.includes('BRAND')) {
            const lower = rawLabel.toLowerCase();
            if (lower === 'deep cool' || lower === 'deepcool') canonicalLabel = 'Deepcool';
            else if (lower.startsWith('western digital')) canonicalLabel = 'Western Digital';
            else if (lower === 'corsair') canonicalLabel = 'CORSAIR';
            else if (lower === 'g.skill' || lower === 'gskill') canonicalLabel = 'G.SKILL';
            else if (lower === 'msi') canonicalLabel = 'MSI';
            else if (lower === 'adata') canonicalLabel = 'ADATA';
            else if (lower === 'asus') canonicalLabel = 'ASUS';
            else if (lower === 'benq') canonicalLabel = 'BENQ';
          } else if (filterType.includes('RAM') || filterType.includes('TYPE')) {
            const lower = rawLabel.toLowerCase();
            if (lower === '6' || lower === '8') {
              li.remove();
              return;
            }
            if (lower === 'ddr5(dual channel)' || lower === 'ddr5') canonicalLabel = 'DDR5';
            else if (lower === 'ddr4') canonicalLabel = 'DDR4';
            else if (lower.includes('gddr6') || lower === 'ddr6') canonicalLabel = 'GDDR6';
          } else if (filterType.includes('WATTAGE')) {
            const num = parseInt(rawLabel, 10);
            if (!isNaN(num) && num < 550) {
              li.remove();
              return;
            }
          } else if (filterType.includes('SPEED')) {
            const num = parseInt(rawLabel, 10);
            if (!isNaN(num) && (num < 2000 || num > 8000)) {
              li.remove();
              return;
            }
          }

          let currentCount = 0;
          if (countEl) {
            const match = countEl.textContent.match(/\d+/);
            if (match) currentCount = parseInt(match[0], 10);
          }

          const key = canonicalLabel.toLowerCase();
          const href = filterItem.getAttribute('data-href');
          const isCurrentActive = li.classList.contains('current-filter');

          if (seenMap.has(key)) {
            const primary = seenMap.get(key);
            primary.count += currentCount;

            if (isCurrentActive) {
              primary.li.classList.add('current-filter');
              const primaryCheckbox = primary.li.querySelector('.checkbox');
              if (primaryCheckbox) primaryCheckbox.classList.add('checked');
            }

            if (href && !primary.hrefs.some((h) => h.href === href)) {
              primary.hrefs.push({ href: href, active: isCurrentActive });
            }

            li.remove();
          } else {
            labelEl.textContent = canonicalLabel;
            seenMap.set(key, {
              li: li,
              filterItem: filterItem,
              labelEl: labelEl,
              countEl: countEl,
              count: currentCount,
              canonicalLabel: canonicalLabel,
              hrefs: href ? [{ href: href, active: isCurrentActive }] : []
            });
          }
        });

        seenMap.forEach((info) => {
          if (info.countEl) {
            info.countEl.textContent = `(${info.count})`;
          }
          if (info.hrefs.length > 1) {
            try {
              const origin = window.location.origin;
              const hasActive = info.hrefs.some((h) => h.active);
              if (hasActive) {
                let base = new URL(info.hrefs[0].href, origin);
                info.hrefs.forEach((h) => {
                  try {
                    const u = new URL(h.href, origin);
                    u.searchParams.forEach((v, k) => {
                      if (base.searchParams.get(k) === v) {
                        base.searchParams.delete(k);
                      }
                    });
                  } catch (e) {}
                });
                info.filterItem.setAttribute('data-href', base.pathname + base.search);
              } else {
                let base = new URL(info.hrefs[0].href, origin);
                info.hrefs.slice(1).forEach((h) => {
                  try {
                    const u = new URL(h.href, origin);
                    u.searchParams.forEach((v, k) => {
                      const existing = base.searchParams.getAll(k);
                      if (!existing.includes(v)) {
                        base.searchParams.append(k, v);
                      }
                    });
                  } catch (e) {}
                });
                info.filterItem.setAttribute('data-href', base.pathname + base.search);
              }
            } catch (e) {}
          }
        });
      });
    },

    ionRangeSlider: function () {
      const price_range = document.querySelector('.price-range');
      const maxRange = document.querySelector(
        options_collection.rangeSliderMax
      );
      const minRange = document.querySelector(
        options_collection.rangeSliderMin
      );
      const minPrice = document.querySelector('.min-price-range');
      const maxPrice = document.querySelector('.max-price-range');
      var minPriceRange = 0;
      var maxPriceRange = 0;
      if (!price_range) return;
      document.querySelector(options_collection.minPriceRange).addEventListener(
        'change',
        (event) => {
          event.preventDefault();
          const target = event.currentTarget;
          target.value = target.value.replace(',', '');
          if (Number(minRange.min) + Number(target.value) >= 0) {
            if (Number(target.value) > Number(maxRange.max)) {
              minPrice.value = Number(maxRange.max);
            } else {
              minPrice.value = Number(target.value);
            }
          } else {
            minPrice.value = Number(minRange.min);
          }
          const formData = new FormData(
            document.querySelector(options_collection.collectionFiltersForm)
          );
          const params = new URLSearchParams(formData).toString();
          const nameMin = minPrice.getAttribute('name');
          const nameMax = maxPrice.getAttribute('name');
          var queryString = window.location.search;
          queryString = this.removeParam(nameMin, queryString);
          queryString = this.removeParam(nameMax, queryString);
          var searchParams = queryString.replace('?', '') + '&' + params;
          const url = this.renderUrl(searchParams);
          this.renderSectionFilter(url, searchParams);
        },
        false
      );
      document.querySelector(options_collection.maxPriceRange).addEventListener(
        'change',
        (event) => {
          event.preventDefault();
          const target = event.currentTarget;
          target.value = target.value.replace(',', '');
          if (Number(maxRange.max) - Number(target.value) >= 0) {
            maxPrice.value = Number(target.value);
          } else {
            maxPrice.value = Number(maxRange.max);
          }
          const formData = new FormData(
            document.querySelector(options_collection.collectionFiltersForm)
          );
          const params = new URLSearchParams(formData).toString();
          const nameMin = minPrice.getAttribute('name');
          const nameMax = maxPrice.getAttribute('name');
          var queryString = window.location.search;
          queryString = this.removeParam(nameMin, queryString);
          queryString = this.removeParam(nameMax, queryString);
          var searchParams = queryString.replace('?', '') + '&' + params;
          const url = this.renderUrl(searchParams);
          this.renderSectionFilter(url, searchParams);
        },
        false
      );
      document
        .querySelector(options_collection.rangeSliderMin)
        .addEventListener(
          'input',
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            if (Number(maxRange.value) - Number(target.value) >= 1) {
              minPrice.value = Number(target.value);
              minPriceRange = Number(target.value) * 100;
            } else {
              target.value = Number(maxRange.value) - 1;
              minPriceRange = (Number(maxRange.value) - 1) * 100;
            }
            const price_format = Shopify.formatMoney(
              minPriceRange,
              cartStrings.money_format
            );
            document.querySelector('.price-lable .min').innerHTML =
              price_format;
            target
              .closest('.price-range')
              .style.setProperty(
                '--range-from',
                (minRange.value / Number(target.getAttribute('max'))) * 100 +
                  '%'
              );
          },
          false
        );
      document
        .querySelector(options_collection.rangeSliderMax)
        .addEventListener(
          'input',
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            if (target.value - minRange.value >= 1) {
              maxPrice.value = target.value;
              maxPriceRange = Number(target.value) * 100;
            } else {
              target.value = Number(minRange.value) + Number(1);
              maxPriceRange = (Number(minRange.value) + Number(1)) * 100;
            }
            const price_format = Shopify.formatMoney(
              maxPriceRange,
              cartStrings.money_format
            );
            document.querySelector('.price-lable .max').innerHTML =
              price_format;
            target
              .closest('.price-range')
              .style.setProperty(
                '--range-to',
                (maxRange.value / Number(target.getAttribute('max'))) * 100 +
                  '%'
              );
          },
          false
        );
      document
        .querySelectorAll(options_collection.rangeSlider)
        .forEach((sliderRange) => {
          sliderRange.addEventListener(
            'change',
            (event) => {
              event.preventDefault();
              const target = event.currentTarget;
              const formData = new FormData(
                document.querySelector(options_collection.collectionFiltersForm)
              );
              const params = new URLSearchParams(formData).toString();
              const nameMin = minPrice.getAttribute('name');
              const nameMax = maxPrice.getAttribute('name');
              var queryString = window.location.search;
              queryString = this.removeParam(nameMin, queryString);
              queryString = this.removeParam(nameMax, queryString);
              var searchParams = queryString.replace('?', '') + '&' + params;
              const url = this.renderUrl(searchParams);
              this.renderSectionFilter(url, searchParams);
            },
            false
          );
        });
    },

    removeParam: function (key, sourceURL) {
      var rtn = sourceURL.split('?')[0],
        param,
        params_arr = [],
        queryString =
          sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : '';
      if (queryString !== '') {
        params_arr = queryString.split('&');
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split('=')[0];
          if (param === key) {
            params_arr.splice(i, 1);
          }
        }
        if (params_arr.length) rtn = rtn + '?' + params_arr.join('&');
      }
      return rtn;
    },

    renderUrl: function (searchParams) {
      const sectionId = document.querySelector(options_collection.section)
        .dataset.sectionId;
      const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
      return url;
    },

    renderSectionFilter: function (url, searchParams) {
      this.toggleLoading(document.body, true);
      fetch(`${url}`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }
          return response.text();
        })
        .then((responseText) => {
          if (window.innerWidth <= 1024) {
            const collectionFilterBlocks = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(options_collection.collectionFilterBlocks);
            document.querySelector(
              options_collection.collectionFilterBlocks
            ).innerHTML = collectionFilterBlocks.innerHTML;
            const productgridcontainer = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(options_collection.productgridcontainer);
            document.querySelector(
              options_collection.productgridcontainer
            ).innerHTML = productgridcontainer.innerHTML;
            if (
              document
                .querySelector(options_collection.collectionSidebar)
                .classList.contains('open')
            ) {
              document.querySelector(options_collection.collectionSidebar).classList.remove('open')
            }
          } else {
            const newSection = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(options_collection.section);
            document
              .querySelector(options_collection.section)
              .replaceWith(newSection);
          }
          document.documentElement.classList.remove('hside_opened', 'open-drawer', 'open-sidebar');
          const sectionElement = document.querySelector(
            '#productgridcontainer'
          );
          
          if (sectionElement) {
            const elementPosition = sectionElement.getBoundingClientRect().top;
            const offsetPosition = window.pageYOffset;
            const extraOffset = 100;
            const scrollToPosition =
              elementPosition + offsetPosition - extraOffset;
            window.scrollTo({
              top: scrollToPosition,
              behavior: 'smooth',
            });
          }
          this.toggleLoading(document.body, false);
        })
        .catch((error) => {
          throw error;
        })
        .finally(() => {
          const motionCollection = document.querySelector(".motion-collection");
          if (motionCollection) {
            motionCollection.reloadAnimationEffect();
          }
          initLazyloadItem();
          BlsLazyloadImg.init();
          eventCollectionShopify.ionRangeSlider();
          eventCollectionShopify.deduplicateFilters();
          eventCollectionShopify.initCustomFilters();
        });
      this.updateUrl(url, searchParams);
    },

    toggleLoading: function (event, loading) {
      if (event) {
        if (loading) {
          event.classList.add('start', 'loading');
        } else {
          event.classList.add('finish');
          setTimeout(function () {
            event.classList.remove('start', 'loading', 'finish');
          }, 500);
        }
      }
    },

    updateUrl: function (url, searchParams = false) {
      if (searchParams) {
        const urlUpdate = `${window.location.pathname}?${searchParams}`;
        window.history.pushState({ url: urlUpdate }, '', urlUpdate);
      } else {
        window.history.pushState({ url: url }, '', url);
      }
    },

    initCustomFilters: function () {
      const customItems = document.querySelectorAll('.custom-filter-item');
      if (!customItems.length) return;

      const self = this;

      // Fetch full collection products to compute 100% accurate global facet counts
      const pathMatches = window.location.pathname.match(/\/collections\/([^/?#]+)/);
      const colHandle = pathMatches ? pathMatches[1] : '';
      if (colHandle && colHandle !== 'all') {
        this.fetchCollectionProducts(colHandle, () => {
          this.updateCustomFilterCounts();
        });
      }

      // Update dynamic live counts
      this.updateCustomFilterCounts();

      // Bind click handlers to custom filter items
      customItems.forEach(function (el) {
        if (el.dataset.customFilterBound) return;
        el.dataset.customFilterBound = 'true';

        el.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          const li = this.closest('li.item');
          const checkbox = this.querySelector('.checkbox');

          // Toggle active state
          if (li.classList.contains('current-filter')) {
            li.classList.remove('current-filter');
            if (checkbox) checkbox.classList.remove('checked');
          } else {
            li.classList.add('current-filter');
            if (checkbox) checkbox.classList.add('checked');
          }

          self.applyCustomFilters();
        });
      });

      // Restore active filters from URL query params
      this.restoreCustomFiltersFromUrl();
    },

    applyCustomFilters: function (skipUrlUpdate) {
      const activeGroups = {};
      document.querySelectorAll('.custom-facet-group').forEach(function (facetGroup) {
        const groupKey = facetGroup.dataset.filterGroup;
        const activeItems = facetGroup.querySelectorAll('li.item.current-filter .custom-filter-item');
        if (activeItems.length > 0) {
          activeGroups[groupKey] = Array.from(activeItems).map(function (i) {
            return (i.dataset.filterVal || '').toLowerCase();
          });
        }

        // Update header active count badge
        const badge = facetGroup.querySelector('.custom-active-count');
        if (badge) {
          if (activeItems.length > 0) {
            badge.textContent = activeItems.length;
            badge.style.display = 'inline-flex';
          } else {
            badge.style.display = 'none';
          }
        }
      });

      const attrMap = {
        category: 'category',
        storage_type: 'storageType',
        storage_interface: 'storageInterface',
        ram_device: 'ramDevice',
        mb_ram_cap: 'mbRamCap',
        panel_type: 'panelType',
        refresh_rate: 'refreshRate',
        cooler_type: 'coolerType',
        color: 'color',
        radiator: 'radiator',
        cabinet_size: 'cabinetSize',
        modular: 'modular',
        cert: 'cert',
        socket: 'socket',
        mb_size: 'mbSize'
      };

      const gridItems = document.querySelectorAll('#product-grid .grid__item:not(.promotion)');
      let visibleCount = 0;

      gridItems.forEach(function (gridItem) {
        const productCard = gridItem.querySelector('.product-item');
        if (!productCard) {
          gridItem.style.display = '';
          return;
        }

        let matchesAll = true;

        for (const [groupKey, activeVals] of Object.entries(activeGroups)) {
          const attrKey = attrMap[groupKey];
          if (!attrKey) continue;

          const prodVal = (productCard.dataset[attrKey] || '').toLowerCase();
          const prodTokens = prodVal.split(/\s+/).filter(Boolean);
          const hasMatch = activeVals.some(function (v) {
            return prodTokens.includes(v) || prodVal === v;
          });

          if (!hasMatch) {
            matchesAll = false;
            break;
          }
        }

        if (matchesAll) {
          gridItem.style.display = '';
          gridItem.classList.remove('custom-filtered-out');
          visibleCount++;
        } else {
          gridItem.style.display = 'none';
          gridItem.classList.add('custom-filtered-out');
        }
      });

      const hasActiveFilters = Object.keys(activeGroups).length > 0;
      const paginationNav = document.querySelector('.pagination, #productgridcontainer nav.pagination, .sec__pagination');
      if (paginationNav) {
        paginationNav.style.display = hasActiveFilters ? 'none' : '';
      }

      if (hasActiveFilters && !this._pagesLoaded && !this._loadingPages) {
        this.ensureAllPagesLoaded(function () {
          self.applyCustomFilters(true);
        });
      } else if (!hasActiveFilters) {
        document.querySelectorAll('#product-grid .grid__item[data-appended-for-filter="true"]').forEach(function (el) {
          el.style.display = 'none';
        });
      }

      // Handle empty state message
      let emptyMsg = document.querySelector('#custom-filter-empty-state');
      const productGrid = document.querySelector('#product-grid');
      const self = this;
      if (productGrid) {
        if (visibleCount === 0 && Object.keys(activeGroups).length > 0) {
          if (!emptyMsg) {
            emptyMsg = document.createElement('div');
            emptyMsg.id = 'custom-filter-empty-state';
            emptyMsg.className = 'w-full py-40 text-center col-12';
            emptyMsg.innerHTML = '<div class="message-info rounded-5 my-0 inline-flex align-center justify-center w-full gap-10 p-20 grey-bg"><span>No products match the selected filters.</span><button type="button" class="btn-link custom-clear-all text-underline font-semibold pointer" style="background:none;border:none;cursor:pointer;text-decoration:underline;">Clear filters</button></div>';
            productGrid.appendChild(emptyMsg);
            emptyMsg.querySelector('.custom-clear-all').addEventListener('click', function () {
              self.clearAllCustomFilters();
            });
          }
          emptyMsg.style.display = 'block';
        } else if (emptyMsg) {
          emptyMsg.style.display = 'none';
        }
      }

      // Update active facet chips (.filter-current)
      this.renderCustomActiveChips(activeGroups);

      // Sync active filters to URL
      if (!skipUrlUpdate) {
        this.syncCustomFiltersToUrl(activeGroups);
      }

      // Update dynamic count labels
      this.updateCustomFilterCounts();

      // Contextual hiding of other facet groups when category is selected
      if (activeGroups.category && activeGroups.category.length > 0) {
        document.querySelectorAll('.custom-facet-group:not([data-filter-group="category"])').forEach(function (facetGroup) {
          const groupKey = facetGroup.dataset.filterGroup;
          const attrKey = attrMap[groupKey];
          if (!attrKey) return;

          let groupHasVisibleProducts = false;
          document.querySelectorAll('#product-grid .grid__item:not(.custom-filtered-out):not(.promotion)').forEach(function (gridItem) {
            const card = gridItem.querySelector('.product-item');
            if (card && card.dataset[attrKey]) {
              groupHasVisibleProducts = true;
            }
          });

          if (!groupHasVisibleProducts && !facetGroup.querySelector('li.item.current-filter')) {
            facetGroup.style.display = 'none';
          }
        });
      }
    },

    renderCustomActiveChips: function (activeGroups) {
      const filterCurrent = document.querySelector('.filter-current');
      if (!filterCurrent) return;
      const ol = filterCurrent.querySelector('ol.filters');
      if (!ol) return;

      ol.querySelectorAll('.custom-facet-chip').forEach(function (el) { el.remove(); });

      const activeGroupKeys = Object.keys(activeGroups);
      const hasCustomActive = activeGroupKeys.length > 0;

      if (!hasCustomActive) {
        const hasNative = ol.querySelectorAll('.filter_remove_item:not(.custom-facet-chip)').length > 0;
        if (!hasNative) {
          filterCurrent.style.display = 'none';
        }
        return;
      }

      filterCurrent.style.display = '';

      let clearLi = ol.querySelector('li:has(.filters_clear), li .filters_clear');
      if (clearLi && !clearLi.matches('li')) {
        clearLi = clearLi.closest('li');
      }

      const self = this;
      document.querySelectorAll('.custom-facet-group li.item.current-filter .custom-filter-item').forEach(function (item) {
        const name = item.dataset.filterName || item.dataset.filterVal;
        const li = document.createElement('li');
        li.className = 'filter_remove_item custom-facet-chip';
        li.innerHTML = '<div class="link-filter inline-flex align-center gap-10 grey-bg rounded-5 btn-hover lh-normal px-20 py-10 transition-short pointer uppercase-first-letter"><span>' + name + '</span><svg width="9" height="9" viewBox="0 0 9 9" fill="none" class="transition"><path d="M1 1L8 8M8 1L1 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></div>';

        li.addEventListener('click', function (e) {
          e.preventDefault();
          const originalLi = item.closest('li.item');
          if (originalLi) {
            originalLi.classList.remove('current-filter');
            const cb = originalLi.querySelector('.checkbox');
            if (cb) cb.classList.remove('checked');
          }
          self.applyCustomFilters();
        });

        if (clearLi) {
          ol.insertBefore(li, clearLi);
        } else {
          ol.appendChild(li);
        }
      });

      let clearBtn = ol.querySelector('.custom-clear-all-chip');
      if (!clearBtn && !ol.querySelector('.filters_clear')) {
        const clearLiNew = document.createElement('li');
        clearLiNew.className = 'custom-clear-all-chip custom-facet-chip';
        clearLiNew.innerHTML = '<button type="button" class="filters_clear border-0 link-filter inline-flex align-center gap-20 rounded-5 btn-active lh-normal px-20 py-10 transition btn-primary body_weight pointer">Clear All</button>';
        clearLiNew.querySelector('button').addEventListener('click', function (e) {
          e.preventDefault();
          self.clearAllCustomFilters();
        });
        ol.appendChild(clearLiNew);
      }
    },

    clearAllCustomFilters: function () {
      document.querySelectorAll('.custom-facet-group li.item.current-filter').forEach(function (li) {
        li.classList.remove('current-filter');
        const cb = li.querySelector('.checkbox');
        if (cb) cb.classList.remove('checked');
      });
      this.applyCustomFilters();
    },

    _loadingPages: false,
    _pagesLoaded: false,
    ensureAllPagesLoaded: function (callback) {
      if (this._pagesLoaded) {
        if (callback) callback();
        return;
      }
      if (this._loadingPages) return;

      const sectionEl = document.querySelector(options_collection.section);
      if (!sectionEl) {
        if (callback) callback();
        return;
      }
      const sectionId = sectionEl.dataset.sectionId;
      const paginationEl = document.querySelector('.pagination, #productgridcontainer nav.pagination, .sec__pagination');
      if (!paginationEl) {
        this._pagesLoaded = true;
        if (callback) callback();
        return;
      }

      // Check max pages from pagination links
      const pageLinks = Array.from(paginationEl.querySelectorAll('a, span')).map(function (el) {
        return parseInt(el.textContent.trim());
      }).filter(function (n) { return !isNaN(n); });
      const maxPage = pageLinks.length ? Math.max.apply(null, pageLinks) : 1;

      if (maxPage <= 1) {
        this._pagesLoaded = true;
        if (callback) callback();
        return;
      }

      this._loadingPages = true;
      const productGrid = document.querySelector('#product-grid');
      const fetchPromises = [];

      for (let p = 2; p <= maxPage; p++) {
        const pageUrl = window.location.pathname + '?section_id=' + sectionId + '&page=' + p;
        fetchPromises.push(
          fetch(pageUrl)
            .then(function (res) { return res.text(); })
            .then(function (html) {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const items = doc.querySelectorAll('#product-grid .grid__item:not(.promotion)');
              return Array.from(items);
            })
            .catch(function () { return []; })
        );
      }

      const self = this;
      Promise.all(fetchPromises).then(function (results) {
        results.forEach(function (items) {
          items.forEach(function (item) {
            item.setAttribute('data-appended-for-filter', 'true');
            item.style.display = 'none';
            if (productGrid) productGrid.appendChild(item);
          });
        });
        self._pagesLoaded = true;
        self._loadingPages = false;
        if (callback) callback();
      });
    },

    extractProductAttrs: function (p) {
      const titleLower = (p.title || '').toLowerCase();
      const bodyLower = (p.body_html || '').toLowerCase();
      const tagsLower = Array.isArray(p.tags) ? p.tags.join(' ').toLowerCase() : (p.tags || '').toLowerCase();
      const typeLower = (p.product_type || '').toLowerCase();
      const combined = titleLower + ' ' + tagsLower + ' ' + bodyLower;

      const attrs = {
        category: '',
        storage_type: '',
        storage_interface: '',
        ram_device: '',
        panel_type: '',
        refresh_rate: '',
        cooler_type: '',
        color: '',
        radiator: '',
        cabinet_size: '',
        modular: '',
        cert: '',
        socket: '',
        mb_size: '',
        mb_ram_cap: ''
      };

      // Category
      if (typeLower === 'motherboard' || titleLower.includes('motherboard') || tagsLower.includes('motherboard') || titleLower.includes('b650m') || titleLower.includes('b760m') || titleLower.includes('h610m') || titleLower.includes('a520m') || titleLower.includes('a620m') || titleLower.includes('b550m') || titleLower.includes('z790') || titleLower.includes('z890') || titleLower.includes('b760') || titleLower.includes('b650') || titleLower.includes('x670') || titleLower.includes('x870')) {
        if (!titleLower.includes('cooler') && !titleLower.includes('cabinet') && !titleLower.includes('case')) {
          attrs.category = 'motherboard';
        }
      }

      if (!attrs.category) {
        if (typeLower === 'cpu' || typeLower === 'processor' || titleLower.includes('processor') || titleLower.includes('ryzen') || titleLower.includes('core i3') || titleLower.includes('core i5') || titleLower.includes('core i7') || titleLower.includes('core i9') || titleLower.includes('core ultra')) {
          if (!titleLower.includes('motherboard') && !titleLower.includes('cooler')) attrs.category = 'cpu';
        }
      }

      if (!attrs.category) {
        if (typeLower.includes('graphic') || typeLower === 'gpu' || titleLower.includes('graphics card') || titleLower.includes('geforce') || titleLower.includes('rtx ') || titleLower.includes('gtx ') || titleLower.includes('arc a') || titleLower.includes('rx 6') || titleLower.includes('rx 7')) {
          attrs.category = 'gpu';
        }
      }

      if (!attrs.category) {
        if (typeLower === 'monitor' || titleLower.includes('monitor') || titleLower.includes('tuf gaming vg') || titleLower.includes('mobiuz')) {
          attrs.category = 'monitor';
        }
      }

      if (!attrs.category) {
        if (typeLower === 'smps' || typeLower.includes('power supply') || titleLower.includes('power supply') || titleLower.includes('smps') || titleLower.includes('mag a') || titleLower.includes('rm750') || titleLower.includes('rm850') || titleLower.includes('rm1000') || titleLower.includes('cx550') || titleLower.includes('cx650') || titleLower.includes('cx750') || titleLower.includes('pk550') || titleLower.includes('pk650') || titleLower.includes('pm750') || titleLower.includes('pm850')) {
          attrs.category = 'smps';
        }
      }

      if (!attrs.category) {
        if (typeLower.includes('ram') || typeLower.includes('memory') || titleLower.includes('memory') || titleLower.includes('trident') || titleLower.includes('ripjaws') || titleLower.includes('vengeance') || titleLower.includes('ddr4') || titleLower.includes('ddr5')) {
          if (!titleLower.includes('motherboard') && !titleLower.includes('processor') && !titleLower.includes('rtx')) {
            attrs.category = 'ram';
          }
        }
      }

      if (!attrs.category) {
        if (typeLower.includes('ssd') || typeLower.includes('hdd') || typeLower.includes('storage') || titleLower.includes('ssd') || titleLower.includes('nvme') || titleLower.includes('hard drive') || titleLower.includes('sn850') || titleLower.includes('sn770') || titleLower.includes('sn580')) {
          attrs.category = 'storage';
        }
      }

      if (!attrs.category) {
        if (typeLower.includes('cooler') || titleLower.includes('cooler') || titleLower.includes('aio') || titleLower.includes('liquid') || titleLower.includes('ak400') || titleLower.includes('ak620') || titleLower.includes('ag400') || titleLower.includes('coreliquid')) {
          if (!titleLower.includes('cabinet') && !titleLower.includes('case')) attrs.category = 'cooler';
        }
      }

      if (!attrs.category) {
        if (typeLower.includes('cabinet') || typeLower.includes('case') || titleLower.includes('cabinet') || titleLower.includes('chassis') || titleLower.includes('mid tower') || titleLower.includes('full tower') || titleLower.includes('4000d') || titleLower.includes('3500x')) {
          attrs.category = 'cabinet';
        }
      }

      // RAM device
      if (attrs.category === 'ram' || titleLower.includes('ram') || titleLower.includes('ddr4') || titleLower.includes('ddr5')) {
        if (combined.includes('so-dimm') || combined.includes('sodimm') || combined.includes('laptop')) {
          attrs.ram_device = 'laptop';
        } else {
          attrs.ram_device = 'desktop';
        }
      }

      // Storage
      if (attrs.category === 'storage' || titleLower.includes('ssd') || titleLower.includes('hard drive') || titleLower.includes('nvme')) {
        if (combined.includes('nvme') || combined.includes('m.2') || combined.includes('pcie') || combined.includes('sn850') || combined.includes('sn770') || combined.includes('sn580') || combined.includes('sn570') || combined.includes('sn350') || combined.includes('gammix')) {
          attrs.storage_interface = 'nvme';
        } else {
          attrs.storage_interface = 'sata';
        }
      }

      // SMPS
      if (attrs.category === 'smps' || titleLower.includes('smps') || titleLower.includes('power supply')) {
        if (combined.includes('titanium')) attrs.cert = 'titanium';
        else if (combined.includes('platinum')) attrs.cert = 'platinum';
        else if (combined.includes('gold')) attrs.cert = 'gold';
        else if (combined.includes('bronze')) attrs.cert = 'bronze';
        else attrs.cert = 'bronze';
      }

      // Motherboard
      if (attrs.category === 'motherboard' || titleLower.includes('motherboard')) {
        // Socket
        if (combined.includes('lga 1851') || combined.includes('lga1851') || combined.includes('z890') || combined.includes('b860') || combined.includes('h810') || titleLower.includes('1851')) {
          attrs.socket = 'lga-1851';
        } else if (combined.includes('lga 1700') || combined.includes('lga1700') || combined.includes('z790') || combined.includes('b760') || combined.includes('h610') || titleLower.includes('1700')) {
          attrs.socket = 'lga-1700';
        } else if (combined.includes('am5') || combined.includes('b650') || combined.includes('x670') || combined.includes('x870') || combined.includes('b850') || combined.includes('b840') || combined.includes('a620')) {
          attrs.socket = 'am5';
        } else if (combined.includes('am4') || combined.includes('b550') || combined.includes('b450') || combined.includes('a520') || titleLower.includes('am4')) {
          attrs.socket = 'am4';
        } else if (combined.includes('lga 1200') || combined.includes('lga1200') || combined.includes('h510') || combined.includes('b560')) {
          attrs.socket = 'lga-1200';
        } else if (combined.includes('lga 1151') || combined.includes('lga1151') || combined.includes('h310') || combined.includes('b365') || combined.includes('b360')) {
          attrs.socket = 'lga-1151';
        }

        // Form Factor
        if (combined.includes('mini-itx') || combined.includes('itx')) {
          attrs.mb_size = 'mini-itx';
        } else if (combined.includes('micro-atx') || combined.includes('m-atx') || combined.includes('matx') || titleLower.includes('b650m') || titleLower.includes('b760m') || titleLower.includes('h610m') || titleLower.includes('a520m') || titleLower.includes('b550m') || titleLower.includes('b850m') || titleLower.includes('z890m') || titleLower.match(/m\s+motherboard/i)) {
          attrs.mb_size = 'micro-atx';
        } else {
          attrs.mb_size = 'atx';
        }

        // RAM Capacity
        if (combined.includes('256gb') || combined.includes('256 gb')) attrs.mb_ram_cap = '256gb';
        else if (combined.includes('192gb') || combined.includes('192 gb')) attrs.mb_ram_cap = '192gb';
        else if (combined.includes('128gb') || combined.includes('128 gb')) attrs.mb_ram_cap = '128gb';
        else if (combined.includes('96gb') || combined.includes('96 gb')) attrs.mb_ram_cap = '96gb';
        else if (combined.includes('64gb') || combined.includes('64 gb')) attrs.mb_ram_cap = '64gb';
        else if (combined.includes('32gb') || combined.includes('32 gb')) attrs.mb_ram_cap = '32gb';
        else if (combined.includes('z890') || combined.includes('z790') || combined.includes('b760') || combined.includes('b650') || combined.includes('x670') || combined.includes('x870')) {
          attrs.mb_ram_cap = '192gb';
        } else {
          attrs.mb_ram_cap = '128gb';
        }
      }

      return attrs;
    },

    fetchCollectionProducts: function (handle, callback) {
      if (!handle || handle === 'all') return;
      if (!window._collectionProductsCache) window._collectionProductsCache = {};
      if (window._collectionProductsCache[handle]) {
        if (callback) callback(window._collectionProductsCache[handle]);
        return;
      }
      const self = this;
      fetch('/collections/' + handle + '/products.json?limit=250')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          const prods = data.products || [];
          prods.forEach(function (p) {
            p._attrs = self.extractProductAttrs(p);
          });
          window._collectionProductsCache[handle] = prods;
          if (callback) callback(prods);
        })
        .catch(function () {});
    },

    updateCustomFilterCounts: function () {
      const attrMap = {
        category: 'category',
        storage_type: 'storageType',
        storage_interface: 'storageInterface',
        ram_device: 'ramDevice',
        mb_ram_cap: 'mbRamCap',
        panel_type: 'panelType',
        refresh_rate: 'refreshRate',
        cooler_type: 'coolerType',
        color: 'color',
        radiator: 'radiator',
        cabinet_size: 'cabinetSize',
        modular: 'modular',
        cert: 'cert',
        socket: 'socket',
        mb_size: 'mbSize'
      };

      const pathMatches = window.location.pathname.match(/\/collections\/([^/?#]+)/);
      const colHandle = pathMatches ? pathMatches[1] : '';
      const cachedProducts = window._collectionProductsCache && window._collectionProductsCache[colHandle];
      const productCards = document.querySelectorAll('#product-grid .product-item');

      document.querySelectorAll('.custom-facet-group').forEach(function (facetGroup) {
        const groupKey = facetGroup.dataset.filterGroup;
        const attrKey = attrMap[groupKey];
        if (!attrKey) return;

        let totalGroupCount = 0;
        facetGroup.querySelectorAll('li.item').forEach(function (li) {
          const val = (li.dataset.filterVal || '').toLowerCase();
          const countEl = li.querySelector('.filter-label-count');
          if (!countEl) return;

          let count = 0;
          if (cachedProducts && cachedProducts.length > 0) {
            cachedProducts.forEach(function (p) {
              const prodVal = (p._attrs && p._attrs[groupKey] ? p._attrs[groupKey] : '').toLowerCase();
              const prodTokens = prodVal.split(/\s+/).filter(Boolean);
              if (prodTokens.includes(val) || prodVal === val) {
                count++;
              }
            });
          } else {
            productCards.forEach(function (card) {
              const prodVal = (card.dataset[attrKey] || '').toLowerCase();
              const prodTokens = prodVal.split(/\s+/).filter(Boolean);
              if (prodTokens.includes(val) || prodVal === val) {
                count++;
              }
            });
          }

          countEl.textContent = '(' + count + ')';
          if (count === 0 && !li.classList.contains('current-filter')) {
            li.classList.add('disabled', 'pointer-none', 'light-dark-grey');
            if (groupKey === 'category') {
              li.style.display = 'none';
            }
          } else {
            li.classList.remove('disabled', 'pointer-none', 'light-dark-grey');
            if (groupKey === 'category') {
              li.style.display = '';
            }
          }
          totalGroupCount += count;
        });

        if (totalGroupCount === 0 && !facetGroup.querySelector('li.item.current-filter')) {
          facetGroup.style.display = 'none';
        } else {
          facetGroup.style.display = '';
        }
      });
    },

    syncCustomFiltersToUrl: function (activeGroups) {
      try {
        const url = new URL(window.location);
        const customKeys = ['category', 'storage_type', 'storage_interface', 'ram_device', 'mb_ram_cap', 'panel_type', 'refresh_rate', 'cooler_type', 'color', 'radiator', 'cabinet_size', 'modular', 'cert', 'socket', 'mb_size'];
        customKeys.forEach(function (k) { url.searchParams.delete(k); });

        for (const [groupKey, vals] of Object.entries(activeGroups)) {
          if (vals.length > 0) {
            url.searchParams.set(groupKey, vals.join(','));
          }
        }
        window.history.replaceState({ url: url.toString() }, '', url.toString());
      } catch (e) {}
    },

    restoreCustomFiltersFromUrl: function () {
      try {
        const url = new URL(window.location);
        const customKeys = ['category', 'storage_type', 'storage_interface', 'ram_device', 'mb_ram_cap', 'panel_type', 'refresh_rate', 'cooler_type', 'color', 'radiator', 'cabinet_size', 'modular', 'cert', 'socket', 'mb_size'];
        let hasParam = false;

        customKeys.forEach(function (key) {
          const paramVal = url.searchParams.get(key);
          if (paramVal) {
            hasParam = true;
            const values = paramVal.toLowerCase().split(',');
            values.forEach(function (v) {
              const itemLi = document.querySelector('.custom-facet-group[data-filter-group="' + key + '"] li.item[data-filter-val="' + v + '"]');
              if (itemLi) {
                itemLi.classList.add('current-filter');
                const cb = itemLi.querySelector('.checkbox');
                if (cb) cb.classList.add('checked');
              }
            });
          }
        });

        if (hasParam) {
          this.applyCustomFilters(true);
        }
      } catch (e) {}
    },
  };
})();
eventCollectionShopify.init();
